import { Component, input, TemplateRef, viewChild, ChangeDetectionStrategy } from '@angular/core';

/**
 * StepComponent is a UI component representing a single step in a stepper or wizard interface.
 *
 * It exposes several configurable inputs that control its state and behavior:
 *
 * @property {string} title - The title of the step, required for identification or display.
 * @property {boolean} disabled - If true, the step is disabled and cannot be interacted with.
 * @property {boolean} canGoPrevious - If true, the user can navigate to the previous step.
 * @property {boolean} canGoNext - If true, the user can navigate to the next step.
 * @property {boolean} loading - If true, indicates that the step is currently in a loading state.
 */
@Component({
  selector: 'mib-step',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './step.component.html',
})
export class StepComponent {
  readonly title = input.required<string>();
  readonly disabled = input<boolean>(false);
  readonly canGoPrevious = input<boolean>(true);
  readonly canGoNext = input<boolean>(true);
  readonly loading = input<boolean>(false);
  readonly loadingMessage = input<string>();

  readonly content = viewChild<TemplateRef<any>>('template');
}
